/**
 * Dynamic Mystery Box Tier Enum
 */
export enum DynamicMysteryBoxTier {
  Bronze = 1,
  Silver = 2,
  Gold = 3,
}

export const DynamicMysteryBoxTierLabels: Record<number, string> = {
  [DynamicMysteryBoxTier.Bronze]: 'Bronze',
  [DynamicMysteryBoxTier.Silver]: 'Silver',
  [DynamicMysteryBoxTier.Gold]: 'Gold',
};
